export default __webpack_public_path__ + "static/media/o2DeliveryIcon.1413e5ec.svg";